import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import { ListServices, PriceListButtons } from "./../Data";
import { useState } from "react";
import { useWindowDimensions } from "./../WindowDimensions";

import "./../style/PriceList.css";
import "./../style/Global.css";

const PriceList = () => {
  const { width } = useWindowDimensions();
  let [listIndex, setListIndex] = useState(0);
  let [isActiveBtn, setIsActiveBtn] = useState(false);
  let buttonsPriceListMobile = document.querySelectorAll(
    ".szh-accordion__item-btn"
  );
  let buttonsPriseListDesktop = document.querySelectorAll(".price-btn");
  const getListIndex = (index) => setListIndex((listIndex = index));

  function changeBtnColor(e) {
    if (
      e.target.classList.contains("szh-accordion__item-btn") ||
      e.target.classList.contains("price-btn")
    ) {
      if (
        !e.target.classList.contains("accordion-active-btn") ||
        !e.target.classList.contains("price-btn-active")
      ) {
        setIsActiveBtn(!isActiveBtn);
        if (width <= 768) {
          buttonsPriceListMobile.forEach((btn) =>
            btn.classList.remove("accordion-active-btn")
          );
          e.target.classList.add("accordion-active-btn");
        } else {
          buttonsPriseListDesktop.forEach((btn) =>
            btn.classList.remove("price-btn-active")
          );
          e.target.classList.add("price-btn-active");
        }
      } else {
        setIsActiveBtn((isActiveBtn = false));
        if (width <= 768) {
          e.target.classList.remove("accordion-active-btn");
        } else {
          e.target.classList.remove("price-btn-active");
        }
      }
    }
  }

  return (
    <div className="price-list-wrapp" id="Price-list">
      {width <= 768 ? (
        <div className="price-list-mobile">
          <Accordion className="accordion">
            {Object.entries(PriceListButtons).map(([, value], index) => (
              <AccordionItem
                className="accordion"
                header={value.btnName}
                key={index}
                onClick={(e) => {
                  changeBtnColor(e);
                  getListIndex(index);
                }}
              >
                <ul className="accordion-item">
                  {Object.entries(ListServices[listIndex]).map(
                    ([key, value], i) => {
                      if (i === 0) return null;
                      return (
                        <li className="price-list-item" key={key}>
                          <span className="listKey">{key}</span>
                          <span className="listValue">{value}</span>
                        </li>
                      );
                    }
                  )}
                </ul>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      ) : (
        <div className="price-list-desktop">
          <div className="price-btns-wrapp">
            {PriceListButtons.map((button, index) => {
              return (
                <button
                  key={index}
                  className="price-btn"
                  onClick={(e) => {
                    changeBtnColor(e);
                    getListIndex(index);
                  }}
                >
                  {button.btnName}
                </button>
              );
            })}
          </div>

          <ul className="price-list">
            {Object.entries(ListServices[listIndex]).map(([key, value], i) => {
              if (i === 0) return null;
              return (
                <li className="price-list-item" key={key}>
                  <span className="listKey">{key}</span>
                  <span className="listValue">{value}</span>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};
export default PriceList;
